// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__27cZV","Loader_dot":"Spinner_Loader_dot__1gvKm","loader":"Spinner_loader__3dXvo"};